const OFFER_BANNER_PREFIX = "offer_banner";

export const OFFER_BANNER_TEST_IDS = {
    BANNER_TITLE: `${OFFER_BANNER_PREFIX}_title`,
    BANNER_CODE: `${OFFER_BANNER_PREFIX}_code`,
    BANNER_CONTAINER: `${OFFER_BANNER_PREFIX}_container`,
};
